<template>
  <div
    class="flex flex-col relative lg:mb-0"
    :class="{ 'md:mb-8': realprice != 0 }"
  >
    <el-form-item :label="$t(label)" :prop="prop" :rules="priceRules">
      <el-input
        :disabled="disabled"
        @input="toCurrency(price)"
        @blur="$emit('blur')"
        type="text"
        v-model="price"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <span
      v-if="realprice != 0"
      class="md:absolute md:top-full right-0 text-gray-500 text-xs mb-4 md:mb-0"
    >
      {{ realprice | toPersianDigits }}
      <span class="font-bold">
        {{ $t('TOMAN') }}
      </span>
    </span>
  </div>
</template>

<script>
import { currency } from '@/mixins/currency'
import { reverseCurrency } from '@/mixins/reverseCurrency'

export default {
  props: ['prop', 'model', 'loading', 'disabled', 'label'],
  mixins: [currency, reverseCurrency],
  data() {
    return {
      price: '',
      realprice: 0,
    }
  },
  computed: {
    priceRules() {
      return [
        {
          required: true,
          trigger: 'blur',
          message: this.$t('REQUIRED_FIELD', { type: this.$t('PRICE') }),
        },
        {
          validator: (rule, value, callback) => {
            if (!this.price) {
              callback(
                new Error(this.$t('REQUIRED_FIELD', { type: this.$t('PRICE') }))
              )
            } else {
              callback()
            }
          },
          trigger: 'blur',
        },
      ]
    },
  },
  methods: {
    toCurrency(val) {
      // Allow only Persian and English digits
      const validInput = val.replace(/[^\d٠١٢٣٤٥٦٧٨٩۰۱۲۳۴۵۶۷۸۹]/g, '')
      this.price = this.toEnglish(this.currency(validInput), false)
      this.$emit('update', this.price)
      this.priceToString()
    },
    priceToString() {
      if (this.reverseCurrency(this.price) > 100) {
        this.realprice = Math.floor(this.reverseCurrency(this.price) / 10)
      } else {
        this.realprice = 0
      }
    },
  },
  watch: {
    model: {
      handler(newVal) {
        this.price = newVal
        this.priceToString()
      },
      immediate: true,
    },
    
  },
}
</script>
